
export const endpoint = {
  case: 'case',
  casePermissions: 'case/access',
  bowtieSupported: 'case/bowtie/supported',
  ui: 'case/ui',
  riskMatrix: 'matrixDefinition/risk',
draft: 'case/draft',
  codetable: 'codetable',
  changeCaseType: (draftId, casetypeId) => `case/draft/${draftId}/casetype/${casetypeId}`,
  caseLog: (isEditing: boolean, id: number) => `case/${isEditing ? 'draft/' : ''}${id}/log`,
  document: (isEditing: boolean, id: number) => `case/${isEditing ? 'draft/' : ''}${id}/document`,
  surveyManagerSupported: 'case/surveymanager/supported',
  riskEvaluationSupported: 'case/riskEvaluation/supported',
  callsToActions: (id: number) => `case/${id}/callsToActions`,
  changeConnectionSequence: (id: number) => `case/${id}/connected/sequence`,
  draftChangeConnectionSequence: (id: number) => `case/draft/${id}/connected/sequence`,
  connectExistingCase: (id: number) => `case/${id}/connections`,
  disconnectCase: (id: number) => `case/${id}/connections`,
  draftChangeConnection: (id: number) => `case/draft/${id}/connections`
};
